import script from "./ExistingProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./ExistingProducts.vue?vue&type=script&setup=true&lang=js"

import "./ExistingProducts.vue?vue&type=style&index=0&id=379cec10&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-379cec10"]])

export default __exports__